import React, { useState } from "react";
import "./Presskit.css";

// Assets
let puppelLogo;
try {
    puppelLogo = require("./images/puppelshow/puppel-left.png");
} catch (e) {
    puppelLogo = null;
}

// Thumbnails — place yt-thumb.png, thumb1.png, thumb2.png, thumb3.png in src/images/
let ytThumb, thumb1, thumb2, thumb3;
try { ytThumb = require("./images/yt-thumb.jpg"); } catch (e) { ytThumb = null; }
try { thumb1 = require("./images/thumb1.png"); } catch (e) { thumb1 = null; }
try { thumb2 = require("./images/thumb2.png"); } catch (e) { thumb2 = null; }
try { thumb3 = require("./images/thumb3.png"); } catch (e) { thumb3 = null; }

const videoEmbed = "https://www.youtube.com/embed/UY85CZWobfc";

const PressKit = () => {
    const [mainContent, setMainContent] = useState({
        type: "video",
        src: videoEmbed,
    });

    const screenshots = [
        { type: "video", src: videoEmbed, thumb: ytThumb, label: "Trailer" },
        { type: "image", src: thumb1, thumb: thumb1, label: "Screenshot 1" },
        { type: "image", src: thumb2, thumb: thumb2, label: "Screenshot 2" },
        { type: "image", src: thumb3, thumb: thumb3, label: "Screenshot 3" },
    ];

    const tags = ["Multiplayer", "Party Game", "Indie"];

    const gameInfo = [
        { label: "Title", value: "Puppel Show" },
        { label: "Developer", value: "Doin' Together Games" },
        { label: "Publisher", value: "Doin' Together Games" },
        { label: "Genre", value: "Multiplayer Party Game" },
        { label: "Platform", value: "PC (Steam)" },
        { label: "Release Date", value: "Coming Soon", highlight: true },
        { label: "Price", value: "TBA" },
    ];

    return (
        <div className="pk">
            {/* Back Button */}
            <button className="pk__back" onClick={() => window.history.back()}>
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                    <path d="M10 12L6 8L10 4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
                Back
            </button>

            <div className="pk__container">
                {/* ===== HEADER ===== */}
                <div className="pk__header">
                    {puppelLogo && (
                        <img src={puppelLogo} alt="Puppel Show" className="pk__header-logo" />
                    )}
                    <div className="pk__header-info">
                        <h1 className="pk__title">Puppel Show</h1>
                        <p className="pk__tagline">
                            Join the competition featuring 4 puppets on a retro TV show!
                            Entertain the audience in different game modes and win the competition to survive!
                        </p>
                        <div className="pk__header-tags">
                            {tags.map((tag) => (
                                <span key={tag} className="pk__tag">{tag}</span>
                            ))}
                        </div>
                    </div>
                </div>

                {/* ===== MAIN CONTENT ===== */}
                <div className="pk__main">
                    {/* Left Column — Media */}
                    <div className="pk__media-col">
                        {/* Main Viewer */}
                        <div className="pk__viewer">
                            {mainContent.type === "video" ? (
                                <div className="pk__video-wrap">
                                    <iframe
                                        src={mainContent.src}
                                        title="Game Trailer"
                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                        allowFullScreen
                                    />
                                </div>
                            ) : (
                                <img
                                    src={mainContent.src}
                                    alt="Screenshot"
                                    className="pk__viewer-img"
                                />
                            )}
                        </div>

                        {/* Thumbnail Strip */}
                        <div className="pk__thumbs">
                            {screenshots.map((item, i) => (
                                <button
                                    key={i}
                                    className={`pk__thumb ${mainContent.src === item.src ? "pk__thumb--active" : ""}`}
                                    onClick={() => setMainContent({ type: item.type, src: item.src })}
                                >
                                    <img src={item.thumb} alt={item.label} />
                                </button>
                            ))}
                        </div>

                        {/* Description */}
                        <div className="pk__section-card">
                            <h2 className="pk__section-title">About This Game</h2>
                            <p className="pk__text">
                                You’re on an old-school TV show. You take the stage as 4 puppets and compete in different game modes.
                                As Baguetto’s puppets, your fate depends on these games. While the strings of the three losers are cut, the winning puppet will perform on stage!
                            </p>
                            {/*
                            <p className="pk__text">
                                Whether you're a mischievous thief hiding as a barrel or a vigilant
                                protector hunting for imposters, every round is packed with laughter,
                                strategy, and pure chaos.
                            </p>
                            */}

                            <h3 className="pk__subsection-title">Features</h3>
                            <ul className="pk__features">
                                <li>4 player multiplayer</li>
                                <li>Multiple game modes</li>
                                <li>Guess who you are</li>
                                <li>Sabotage the others</li>
                                <li>Quick rounds perfect for party sessions</li>
                            </ul>
                        </div>

                        {/* Download Assets */}
                        <div className="pk__section-card">
                            <h2 className="pk__section-title">Press Assets</h2>
                            <div className="pk__downloads">
                                <button className="pk__download-btn">
                                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                        <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4M7 10l5 5 5-5M12 15V3" />
                                    </svg>
                                    Screenshots
                                </button>
                                <button className="pk__download-btn">
                                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                        <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4M7 10l5 5 5-5M12 15V3" />
                                    </svg>
                                    Logo &amp; Branding
                                </button>
                                <button className="pk__download-btn">
                                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                        <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4M7 10l5 5 5-5M12 15V3" />
                                    </svg>
                                    Video Trailers
                                </button>
                            </div>
                        </div>
                    </div>

                    {/* Right Column — Sidebar */}
                    <div className="pk__sidebar">
                        {/* Game Info Card */}
                        <div className="pk__info-card">
                            {puppelLogo && (
                                <img src={puppelLogo} alt="Puppel Show" className="pk__info-logo" />
                            )}

                            <p className="pk__info-desc">
                                In this 4-player party game, your goal is to beat your friends in different game modes.
                                Sometimes by competing against each other, and sometimes by building friendships—try to be the last puppet standing!
                            </p>

                            <a
                                href="https://store.steampowered.com/app/4553750/Puppel_Show"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="pk__steam-btn"
                            >
                                <svg viewBox="0 0 65 65" width="20" height="20">
                                    <path d="M1.305 41.202C5.259 54.386 17.488 64 31.959 64c17.673 0 32-14.327 32-32s-14.327-32-32-32C15.001 0 1.124 13.193.028 29.874c2.074 3.477 2.879 5.628 1.275 11.328z" fill="#1b2838" />
                                    <path d="M30.31 23.985l.003.158-7.83 11.375c-1.268-.058-2.54.165-3.748.662a8.14 8.14 0 0 0-1.498.8L.042 29.893s-.398 6.546 1.26 11.424l12.156 5.016c.6 2.728 2.48 5.12 5.242 6.27a8.88 8.88 0 0 0 11.603-4.782 8.89 8.89 0 0 0 .684-3.656L42.18 36.16l.275.005c6.705 0 12.155-5.466 12.155-12.18s-5.44-12.16-12.155-12.174c-6.702 0-12.155 5.46-12.155 12.174zm-1.88 23.05c-1.454 3.5-5.466 5.147-8.953 3.694a6.84 6.84 0 0 1-3.524-3.362l3.957 1.64a5.04 5.04 0 0 0 6.591-2.719 5.05 5.05 0 0 0-2.715-6.601l-4.1-1.695c1.578-.6 3.372-.62 5.05.077 1.7.703 3 2.027 3.696 3.72s.692 3.56-.01 5.246M42.466 32.1a8.12 8.12 0 0 1-8.098-8.113 8.12 8.12 0 0 1 8.098-8.111 8.12 8.12 0 0 1 8.1 8.111 8.12 8.12 0 0 1-8.1 8.113m-6.068-8.126a6.09 6.09 0 0 1 6.08-6.095c3.355 0 6.084 2.73 6.084 6.095a6.09 6.09 0 0 1-6.084 6.093 6.09 6.09 0 0 1-6.081-6.093z" fill="#f3ecd8" />
                                </svg>
                                View on Steam
                            </a>

                            <div className="pk__info-divider"></div>

                            {/* Game details */}
                            <div className="pk__details">
                                {gameInfo.map((info) => (
                                    <div key={info.label} className="pk__detail-row">
                                        <span className="pk__detail-label">{info.label}</span>
                                        <span className={`pk__detail-value ${info.highlight ? "pk__detail-value--highlight" : ""}`}>
                                            {info.value}
                                        </span>
                                    </div>
                                ))}
                            </div>

                            <div className="pk__info-divider"></div>

                            {/* Tags */}
                            <div className="pk__info-tags">
                                <span className="pk__info-tags-label">Tags</span>
                                <div className="pk__info-tags-list">
                                    {tags.map((tag) => (
                                        <span key={tag} className="pk__tag pk__tag--small">{tag}</span>
                                    ))}
                                </div>
                            </div>

                            <div className="pk__info-divider"></div>

                            {/* Languages */}
                            <div className="pk__languages">
                                <span className="pk__info-tags-label">Languages</span>
                                <div className="pk__lang-list">
                                    <span>🇬🇧 English</span>
                                    <span>🇹🇷 Türkçe</span>
                                </div>
                            </div>
                        </div>

                        {/* Contact Card */}
                        <div className="pk__contact-card">
                            <h3 className="pk__contact-title">Contact</h3>
                            <a href="mailto:dointogethergames@gmail.com" className="pk__contact-email">
                                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                    <rect x="2" y="4" width="20" height="16" rx="2" />
                                    <path d="M22 7l-10 7L2 7" />
                                </svg>
                                dointogethergames@gmail.com
                            </a>
                            <div className="pk__contact-socials">
                                <a href="https://x.com/dointogether" target="_blank" rel="noopener noreferrer" className="pk__contact-link">𝕏 Twitter</a>
                                <a href="https://www.instagram.com/dointogethergames/" target="_blank" rel="noopener noreferrer" className="pk__contact-link">Instagram</a>
                                <a href="https://www.linkedin.com/company/dointogethergames/" target="_blank" rel="noopener noreferrer" className="pk__contact-link">LinkedIn</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PressKit;
